import { useI18n } from "@/lib/i18n";

export default function LanguageSwitcher({ testId = "lang-switcher" }) {
  const { lang, setLang } = useI18n();
  return (
    <div data-testid={testId} className="inline-flex items-center overflow-hidden rounded-full border border-current/20 text-xs font-mono">
      {["es", "en"].map((l) => (
        <button
          key={l}
          onClick={() => setLang(l)}
          data-testid={`lang-${l}`}
          className={`px-2.5 py-1 uppercase tracking-widest transition-colors ${
            lang === l ? "bg-current/10 font-semibold" : "opacity-50 hover:opacity-100"
          }`}
        >
          {l}
        </button>
      ))}
    </div>
  );
}
